/*!
 * @Author: Tolga MALKOC / ghostlexly@gmail.com
 */

var bearer = {
	request: function (req, token) {
		this.drivers.http.setHeaders.call(this, req, {
			'x-auth-token': 'Bearer ' + token,
		});
	},
	response: function (res) {
		let headers = this.drivers.http.getHeaders.call(this, res);
		//let token = headers.Authorization || headers.authorization;

		if (Boolean(res.data.token) === true) {
			return res.data.token;
		}
	},
};

export default bearer;
